export default {
  name: "PrivacyPolicy"
};